module.exports = __webpack_public_path__ + "img/list4.888e304a.jpg";